var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Outlined / Select"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 1.75H2.75C2.47344 1.75 2.25 1.97344 2.25 2.25V13.75C2.25 14.0266 2.47344 14.25 2.75 14.25H8.375C8.44375 14.25 8.5 14.1938 8.5 14.125V13.25C8.5 13.1812 8.44375 13.125 8.375 13.125H3.375V2.875H13.625V7.875C13.625 7.94375 13.6812 8 13.75 8H14.625C14.6938 8 14.75 7.94375 14.75 7.875V2.25C14.75 1.97344 14.5266 1.75 14.25 1.75ZM10.7078 9.36563L11.5234 8.55C11.54 8.5334 11.5515 8.51249 11.5567 8.48965C11.5619 8.46682 11.5607 8.44298 11.553 8.42084C11.5454 8.3987 11.5316 8.37915 11.5134 8.36442C11.4952 8.34969 11.4732 8.34036 11.45 8.3375L8.64688 8.00937C8.56719 8 8.49844 8.06719 8.50781 8.14844L8.83594 10.9516C8.84844 11.0547 8.975 11.0984 9.04844 11.025L9.86719 10.2063L13.8703 14.2094C13.9187 14.2578 13.9984 14.2578 14.0469 14.2094L14.7094 13.5469C14.7578 13.4984 14.7578 13.4187 14.7094 13.3703L10.7078 9.36563Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.55acf399c99938f7c00c58bd8f591e25.svg";
export { ForwardRef as ReactComponent };